import { MenuIcon } from "./icons";
import { SheetOverlay } from "./SheetOverlay";
import type { AccountView } from "./view-model";

export interface MoreSheetProps {
  friendBadge?: number;
  account?: AccountView;
  onOpenFriends(): void;
  onOpenShop(): void;
  onOpenSettings(): void;
  onOpenSave(): void;
  onClose(): void;
}

export function MoreSheet({
  friendBadge = 0,
  account,
  onOpenFriends,
  onOpenShop,
  onOpenSettings,
  onOpenSave,
  onClose,
}: MoreSheetProps) {
  const badgeCount = Math.max(0, Math.floor(friendBadge));

  const saveHelp =
    account?.signedIn && account?.username
      ? `Saved as ${account.username}`
      : "Play on any device with Google or a username";

  return (
    <SheetOverlay
      testId="more-sheet"
      title="More"
      onClose={onClose}
    >
      <div className="sb">
        <div className="more-grid">
          <button
            type="button"
            className="more-row"
            data-testid="menu-friends"
            onClick={onOpenFriends}
          >
            <span className="more-icon">
              <MenuIcon id="friends" />
            </span>
            <div className="more-info">
              <div className="more-title">
                Friends
                {badgeCount > 0 ? (
                  <span className="more-badge" data-testid="friend-badge">
                    {badgeCount}
                  </span>
                ) : null}
              </div>
              <div className="more-sub">Friend codes, requests and picture books</div>
            </div>
          </button>

          <button
            type="button"
            className="more-row"
            data-testid="menu-shop"
            onClick={onOpenShop}
          >
            <span className="more-icon">
              <MenuIcon id="shop" />
            </span>
            <div className="more-info">
              <div className="more-title">Shop</div>
              <div className="more-sub">Habitats, shells and pool packs</div>
            </div>
          </button>

          <button
            type="button"
            className="more-row"
            data-testid="menu-settings"
            onClick={onOpenSettings}
          >
            <span className="more-icon">
              <MenuIcon id="settings" />
            </span>
            <div className="more-info">
              <div className="more-title">Settings</div>
              <div className="more-sub">Controls, meters and comfort</div>
            </div>
          </button>

          <button
            type="button"
            className="more-row"
            data-testid="menu-save"
            onClick={onOpenSave}
          >
            <span className="more-icon">
              <MenuIcon id="save" />
            </span>
            <div className="more-info">
              <div className="more-title">Save my game</div>
              <div className="more-sub">{saveHelp}</div>
            </div>
          </button>
        </div>
      </div>
    </SheetOverlay>
  );
}
